import { BeneficiarySummary } from "@beneficiary/domain/models/beneficiary-summary.model";

export class BeneficiariesSummary {
    constructor(
        public readonly beneficiariesSummary: BeneficiarySummary[],
        public readonly count: number,
    ) {}
}
